import AnalysisStudyListConstants from "./AnalysisStudyListConstants.js";
import GarConstants from "../../../GarView/models/GarConstants.js";
function setRouteContext(routeContext) {
  return {
    type: AnalysisStudyListConstants.SET_ROUTE_CONTEXT,
    payload: routeContext
  };
}
function loadV2StudyAbstractsForStepId(payload) {
  return {
    type: AnalysisStudyListConstants.V2_LOAD_STUDY_ABSTRACTS_FOR_STEP_ID,
    payload
  };
}
function loadingV2StudyAbstractsForStepId(stepId) {
  return {
    type: AnalysisStudyListConstants.V2_LOADING_STUDY_ABSTRACTS_FOR_STEP_ID,
    payload: stepId
  };
}
function loadedV2StudyAbstractsForStepIdLegacy(stepId, v2StudyAbstracts, workspaceRedirect) {
  return {
    type: AnalysisStudyListConstants.V2_LOADED_STUDY_ABSTRACTS_FOR_STEP_ID_LEGACY,
    payload: { stepId, v2StudyAbstracts, workspaceRedirect }
  };
}
function loadedV2StudyAbstractsForStepId(stepId, request, workspaceRedirect) {
  return {
    type: AnalysisStudyListConstants.V2_LOADED_STUDY_ABSTRACTS_FOR_STEP_ID,
    payload: { stepId, request, workspaceRedirect }
  };
}
function registerAnalysisForStepId(workspaceId, stepId) {
  return {
    type: AnalysisStudyListConstants.REGISTER_ANALYSIS_FOR_STEP,
    payload: { workspaceId, stepId }
  };
}
function registeringAnalysisForStepId() {
  return {
    type: AnalysisStudyListConstants.REGISTERING_ANALYSIS_FOR_STEP,
    payload: {}
  };
}
function registeredAnalysisForStepId(registerAnalysisAsync) {
  return {
    type: AnalysisStudyListConstants.REGISTERED_ANALYSIS_FOR_STEP,
    payload: { registerAnalysisAsync }
  };
}
function loadV2StudyAbstract(payload) {
  return {
    type: AnalysisStudyListConstants.V2_LOAD_STUDY_ABSTRACT,
    payload
  };
}
function loadingV2StudyAbstract(payload) {
  return {
    type: AnalysisStudyListConstants.V2_LOADING_STUDY_ABSTRACT,
    payload
  };
}
function loadedV2StudyAbstract(payload) {
  return {
    type: AnalysisStudyListConstants.V2_LOADED_STUDY_ABSTRACT,
    payload
  };
}
function loadedWorkspaceSplitRedirect(payload) {
  return {
    type: AnalysisStudyListConstants.V2_LOADED_WORKSPACE_REDIRECT,
    payload
  };
}
function loadV2TaskLogs(payload) {
  return {
    type: AnalysisStudyListConstants.V2_LOAD_TASK_LOGS,
    payload
  };
}
function loadingV2TaskLogs(payload) {
  return {
    type: AnalysisStudyListConstants.V2_LOADING_TASK_LOGS,
    payload
  };
}
function loadedV2TaskLogs(payload) {
  return {
    type: AnalysisStudyListConstants.V2_LOADED_TASK_LOGS,
    payload
  };
}
const loadTaskOverviewInfoForScorecardId = (payload) => {
  return {
    type: AnalysisStudyListConstants.LOAD_TASK_OVERVIEW_INFO_FOR_SCORECARDID,
    payload
  };
};
const loadingTaskOverviewInfoForScorecardId = (payload) => {
  return {
    type: AnalysisStudyListConstants.LOADING_TASK_OVERVIEW_INFO_FOR_SCORECARDID,
    payload
  };
};
const loadedTaskOverviewInfoForScorecardId = (payload) => {
  return {
    type: AnalysisStudyListConstants.LOADED_TASK_OVERVIEW_INFO_FOR_SCORECARDID,
    payload
  };
};
function loadedStudiesForStepId() {
  return {
    type: AnalysisStudyListConstants.LOADED_STUDIES_FOR_STEP_ID
  };
}
function loadingStudyAbstractsForStepId(stepId) {
  return {
    type: AnalysisStudyListConstants.LOADING_STUDY_ABSTRACTS_FOR_STEP_ID,
    payload: stepId
  };
}
function loadedStudyAbstractsForStepId(stepId, studyAbstracts) {
  return {
    type: AnalysisStudyListConstants.LOADED_STUDY_ABSTRACTS_FOR_STEP_ID,
    payload: { stepId, studyAbstracts }
  };
}
function loadStudiesForStudyIds(studyIds) {
  return {
    type: AnalysisStudyListConstants.LOAD_STUDIES_FOR_STUDY_IDS,
    payload: studyIds
  };
}
function loadStudyForStudyId(studyId) {
  return {
    type: AnalysisStudyListConstants.LOAD_STUDY_FOR_STUDY_ID,
    payload: studyId
  };
}
function loadingStudy(studyId) {
  return {
    type: AnalysisStudyListConstants.LOADING_STUDY,
    payload: studyId
  };
}
function loadedStudy(studyId, studyData) {
  return {
    type: AnalysisStudyListConstants.LOADED_STUDY,
    payload: { studyId, studyData }
  };
}
function loadForayConfigMetadata() {
  return {
    type: AnalysisStudyListConstants.LOAD_FORAY_CONFIG_METADATA
  };
}
function loadingForayConfigMetadata() {
  return {
    type: AnalysisStudyListConstants.LOADING_FORAY_CONFIG_METADATA
  };
}
function loadedForayConfigMetadata(forayConfigMetadata) {
  return {
    type: AnalysisStudyListConstants.LOADED_FORAY_CONFIG_METADATA,
    payload: forayConfigMetadata
  };
}
function loadAnalysisStepProperties(stepId) {
  return {
    type: AnalysisStudyListConstants.LOAD_ANALYSIS_STEP_PROPERTIES,
    payload: stepId
  };
}
function loadingAnalysisStepProperties() {
  return {
    type: AnalysisStudyListConstants.LOADING_ANALYSIS_STEP_PROPERTIES
  };
}
function loadedAnalysisStepPropertiesLegacy(analysisStepProperties) {
  return {
    type: AnalysisStudyListConstants.LOADED_ANALYSIS_STEP_PROPERTIES_LEGACY,
    payload: analysisStepProperties
  };
}
function loadedAnalysisStepProperties(request) {
  return {
    type: AnalysisStudyListConstants.LOADED_ANALYSIS_STEP_PROPERTIES,
    payload: request
  };
}
function setPartialUserContext(userContext) {
  return {
    type: GarConstants.SET_PARTIAL_USER_CONTEXT,
    payload: userContext
  };
}
function setUserContext(userContext) {
  return {
    type: GarConstants.SET_USER_CONTEXT,
    payload: userContext
  };
}
function enableStudy(payload) {
  return {
    type: AnalysisStudyListConstants.ENABLE_STUDY,
    payload
  };
}
function studyEnabled(payload) {
  return {
    type: AnalysisStudyListConstants.SET_STUDY_ENABLED,
    payload
  };
}
function disableStudy(payload) {
  return {
    type: AnalysisStudyListConstants.DISABLE_STUDY,
    payload
  };
}
function studyDisabled(payload) {
  return {
    type: AnalysisStudyListConstants.SET_STUDY_DISABLED,
    payload
  };
}
function deleteStudy(payload) {
  return {
    type: AnalysisStudyListConstants.DELETE_STUDY,
    payload
  };
}
function studyDeleted(payload) {
  return {
    type: AnalysisStudyListConstants.SET_STUDY_DELETED,
    payload
  };
}
function studyStateUpdating(payload) {
  return {
    type: AnalysisStudyListConstants.STUDY_STATE_UPDATING,
    payload
  };
}
function getRawStudy(rawStudyActionPayload) {
  return {
    type: AnalysisStudyListConstants.LOAD_RAW_STUDY,
    payload: rawStudyActionPayload
  };
}
function gettingRawStudy(rawStudyActionPayload) {
  return {
    type: AnalysisStudyListConstants.LOADING_RAW_STUDY,
    payload: rawStudyActionPayload
  };
}
function loadedRawStudy(rawStudyActionResultPayload) {
  return {
    type: AnalysisStudyListConstants.LOADED_RAW_STUDY,
    payload: rawStudyActionResultPayload
  };
}
const toggleForayParameters = (showForayParameters) => {
  return {
    type: AnalysisStudyListConstants.TOGGLE_SHOW_FORAY_PARAMETER,
    payload: {
      showForayParameters
    }
  };
};
export {
  deleteStudy,
  disableStudy,
  enableStudy,
  getRawStudy,
  gettingRawStudy,
  loadAnalysisStepProperties,
  loadForayConfigMetadata,
  loadStudiesForStudyIds,
  loadStudyForStudyId,
  loadTaskOverviewInfoForScorecardId,
  loadV2StudyAbstract,
  loadV2StudyAbstractsForStepId,
  loadV2TaskLogs,
  loadedAnalysisStepProperties,
  loadedAnalysisStepPropertiesLegacy,
  loadedForayConfigMetadata,
  loadedRawStudy,
  loadedStudiesForStepId,
  loadedStudy,
  loadedStudyAbstractsForStepId,
  loadedTaskOverviewInfoForScorecardId,
  loadedV2StudyAbstract,
  loadedV2StudyAbstractsForStepId,
  loadedV2StudyAbstractsForStepIdLegacy,
  loadedV2TaskLogs,
  loadedWorkspaceSplitRedirect,
  loadingAnalysisStepProperties,
  loadingForayConfigMetadata,
  loadingStudy,
  loadingStudyAbstractsForStepId,
  loadingTaskOverviewInfoForScorecardId,
  loadingV2StudyAbstract,
  loadingV2StudyAbstractsForStepId,
  loadingV2TaskLogs,
  registerAnalysisForStepId,
  registeredAnalysisForStepId,
  registeringAnalysisForStepId,
  setPartialUserContext,
  setRouteContext,
  setUserContext,
  studyDeleted,
  studyDisabled,
  studyEnabled,
  studyStateUpdating,
  toggleForayParameters
};
//# sourceMappingURL=AnalysisStudyListActions.js.map
